import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import { formatTimelineTimestamp } from './timelineDateUtils';

const TimelineIcon = ({ state }) => {
  if (state === 'completed') {
    return (
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: '50%',
          bgcolor: '#23B80C33',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <CheckIcon sx={{ color: '#23B80C', fontSize: 20 }} />
      </Box>
    );
  }

  if (state === 'in_progress') {
    return (
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: '50%',
          bgcolor: '#FFC70033',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <HourglassEmptyOutlinedIcon sx={{ color: '#FF8A00', fontSize: 20 }} />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: 36,
        height: 36,
        borderRadius: '50%',
        bgcolor: '#eceff3',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <ScheduleOutlinedIcon sx={{ color: '#9aa3ad', fontSize: 20 }} />
    </Box>
  );
};

const StatusTimelineCard = ({
  title = 'Status Timeline',
  steps = [],
  inProgressLabel = 'In Progress',
  pendingLabel = 'Pending',
  formatTimestamp = formatTimelineTimestamp,
  containerSx = {},
}) => (
  <Box
    sx={(theme) => ({
      bgcolor: 'background.paper',
      borderRadius: 2.5,
      p: 2,
      boxShadow: theme.shadows[1],
      ...containerSx,
    })}
  >
    <Typography sx={{ fontWeight: 600, fontSize: '1.15rem', color: 'text.primary', mb: 1.75 }}>
      {title}
    </Typography>
    <Box>
      {steps.map((step, index) => (
        <Box
          key={step.id ?? index}
          sx={{
            display: 'flex',
            gap: 1.5,
            position: 'relative',
            pb: index === steps.length - 1 ? 0 : 2.25,
          }}
        >
          {index < steps.length - 1 ? (
            <Box
              sx={{
                position: 'absolute',
                left: 17,
                top: 38,
                bottom: 0,
                width: 2,
                bgcolor: 'divider',
              }}
            />
          ) : null}
          <TimelineIcon state={step.state} />
          <Box sx={{ flex: 1, pt: 0.25 }}>
            <Typography sx={{ fontWeight: 500, fontSize: '0.95rem', lineHeight: 1.3 }}>
              {step.title}
            </Typography>
            {(step.timestamp || step.state === 'in_progress' || step.state === 'pending') && (
              <Typography sx={{ mt: 0.35, color: 'text.secondary', fontSize: '0.83rem' }}>
                {step.timestamp
                  ? formatTimestamp(step.timestamp)
                  : step.state === 'in_progress'
                    ? inProgressLabel
                    : pendingLabel}
              </Typography>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  </Box>
);

export default StatusTimelineCard;
